// Thumbnail image for store lists: uses Supabase Image Transform (small, fast).
// If transform fails (e.g. free tier), falls back to cover URL so the list still shows.

import { useState } from 'react';
import { getThumbnailUrl } from '@/lib/store-images';

export interface StoreThumbnailImgProps {
  coverUrl: string | null | undefined;
  size?: { width?: number; height?: number };
  className?: string;
  alt?: string;
}

/**
 * Renders thumbnail for lists: requests resized image (Pro) for fast load.
 * On error (e.g. transform not available on free tier), falls back to cover URL.
 */
export function StoreThumbnailImg({
  coverUrl,
  size,
  className = '',
  alt = '',
}: StoreThumbnailImgProps) {
  const thumbUrl = getThumbnailUrl(coverUrl, size) ?? coverUrl ?? null;
  const [src, setSrc] = useState(thumbUrl);
  const fallbackUrl = coverUrl ?? null;

  if (!coverUrl) return null;

  const handleError = () => {
    if (fallbackUrl && src !== fallbackUrl) setSrc(fallbackUrl);
  };

  return (
    <img
      src={src ?? undefined}
      alt={alt}
      className={className}
      onError={handleError}
      loading="lazy"
    />
  );
}
